// extracted by mini-css-extract-plugin
module.exports = {"container":"EbsCustomAlert_container__qubqo","largeRadius":"EbsCustomAlert_largeRadius__X7PDH","smallFont":"EbsCustomAlert_smallFont__Eu2wy","large":"EbsCustomAlert_large____4w7"};